document.addEventListener('bundler:loaded', function (e) {
  console.log('Bundler loaded');

  // Function to hide the original Bundler volume discount widget
  function hideOriginalBundlerWidget() {
    const bundlerWidget = document.querySelector('.bundler-volume-target-element');
    if (bundlerWidget) {
      console.log(bundlerWidget);
      bundlerWidget.style.display = 'none';
    }
  }

  // Function to extract discount tiers from the Bundler widget and display them in a custom element
  function extractAndDisplayDiscountTiers() {
    const discountContainer = document.querySelector('.bndlr-volume-discounts');
    console.log(discountContainer);

    if (discountContainer) {
      // Hide the original Bundler widget
      hideOriginalBundlerWidget();

      // Extract discount tiers
      const discounts = discountContainer.querySelectorAll('.bndlr-volume-discount');
      const customDiscountContainer = document.querySelector('#volume-discount-container');

      if (!customDiscountContainer) return false;

      // Clear any existing content
      customDiscountContainer.innerHTML = '';

      // Define the original price of the product - replace with your actual logic to get the original price
      const originalPrice = parseFloat(customDiscountContainer.getAttribute('data-price') || '0');

      // Loop through each discount tier and dynamically create your custom element
      discounts.forEach((discount, index) => {
        const quantity = discount.getAttribute('data-quantity');
        const discountText = discount.querySelector('.bndlr-volume-main-text').textContent.trim();
        const savingText = discount.querySelector('.bndlr-volume-saving-text').textContent.trim();

        // Extract the discount percentage (e.g., "Save 10%!")
        const percentageMatch = savingText.match(/(\d+)%/);
        const discountPercentage = percentageMatch ? parseFloat(percentageMatch[1]) : 0;

        // Calculate the discounted price per item
        const discountedPrice = originalPrice * (1 - discountPercentage / 100);

        // Calculate the discount amount per item
        const discountAmount = originalPrice - discountedPrice;

        // Format the prices for display
        const formattedDiscountedPrice = discountedPrice.toFixed(2).replace('.', ',');
        const formattedDiscountAmount = discountAmount.toFixed(2).replace('.', ',');

        // Create your custom HTML structure for each discount tier
        const customDiscountHTML = `
          <div class="flex items-center justify-between bg-white px-2 sm:px-6 xl:px-10 py-3 sm:py-4 border border-[#DDD9D9] mb-2" data-volume-quantity="${quantity}">
            <div class="flex items-center w-1/4">
              <span class="font-bold underline text-xs md:text-sm cursor-pointer">${quantity} Stück</span>
            </div>
            <div class="border-l border-gray-300 h-full mx-4"></div>
            <div class="flex items-center border-x border-[#DDD9D9] px-3 sm:px-6 xl:px-12 justify-center text-xs md:text-sm w-1/2">
              <span>${formattedDiscountedPrice} &euro; pro Stück</span>
            </div>
            <div class="border-l border-gray-300 h-full mx-4"></div>
            <div class="flex items-center justify-end text-light font-bold text-xs md:text-sm w-1/3 pl-4">
              <span>${formattedDiscountAmount} &euro; Rabatt</span>
            </div>
          </div>
        `;

        // Append the custom HTML to your custom discount container
        customDiscountContainer.innerHTML += customDiscountHTML;

        const volumeButtons = document.querySelectorAll('[data-volume-quantity]');
        console.log('volumeButtons', volumeButtons);
        volumeButtons.forEach((button) => {
          button.addEventListener('click', function () {
            const quantity = button.getAttribute('data-volume-quantity');
            console.log('change qty', quantity);
            document.getElementById('output-trees').value = quantity;
            document.querySelector(`[data-type="add-to-cart-form"] [name="quantity"]`).value = quantity;
            updateMeters();
          });
        });
      });
    }
  }

  // Initialize extraction and display on page load
  setTimeout(() => {
    extractAndDisplayDiscountTiers();

    // Listen for variant changes
    document.addEventListener('variant:changed', function (event) {
      const variant = event.detail.variant;
      if (variant && variant.price) {
        const customDiscountContainer = document.querySelector('#volume-discount-container');
        if (customDiscountContainer) {
          customDiscountContainer.setAttribute('data-price', variant.price / 100);
          extractAndDisplayDiscountTiers();
        }
      }
    });

    // Trigger variant:changed event with current variant
    const currentVariantId = document.querySelector('input[name="id"]').value;
    const variantData = product.variants.find((v) => v.id.toString() === currentVariantId);
    if (variantData) {
      const event = new CustomEvent('variant:changed', {
        detail: { variant: variantData },
      });
      document.dispatchEvent(event);
    }
  }, 1000);
});
